import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  Query,
  ViewChild,
} from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { PrIconComponent } from '../pr-icon/pr-icon.component';

@Component({
    selector: 'pr-theme-switch',
    templateUrl: './pr-theme-switch.component.html',
    styleUrls: ['./pr-theme-switch.component.scss'],
    standalone: false
})
export class PrThemeSwitchComponent implements OnInit {
  @Input() automaticSwitch = true;
  @Input() variant: 'DEFAULT' | 'SWITCH' = 'DEFAULT';
  STORAGE_THEME_KEY = 'theme';
  theme: 'light' | 'dark' = 'light';

  constructor() {}

  ngOnInit(): void {
    if (localStorage.getItem(this.STORAGE_THEME_KEY)) {
      this.theme = <'light' | 'dark'>(
        localStorage.getItem(this.STORAGE_THEME_KEY)
      );
    } else {
      if (this.automaticSwitch)
        this.theme = window.matchMedia('(prefers-color-scheme: dark)').matches
          ? 'dark'
          : 'light';
    }
    this.applyTheme();

    //Listen changes
    if (this.automaticSwitch)
      window
        .matchMedia('(prefers-color-scheme: dark)')
        .addEventListener('change', event =>
          event.matches
            ? this.onThemeChange('dark')
            : this.onThemeChange('light'),
        );
  }

  toggleTheme(): void {
    this.onThemeChange();
    localStorage.setItem(this.STORAGE_THEME_KEY, this.theme);
  }

  changeTheme(theme: 'light' | 'dark'): void {
    this.onThemeChange(theme);
    localStorage.setItem(this.STORAGE_THEME_KEY, this.theme);
  }

  onThemeChange(theme?: 'light' | 'dark') {
    this.theme = theme ? theme : this.theme == 'dark' ? 'light' : 'dark';
    this.applyTheme();
  }

  applyTheme(): void {
    const classList = document.documentElement.classList;
    classList.remove('theme-dark', 'theme-light');
    document.documentElement.classList.add(`theme-${this.theme}`);
  }

  @HostListener('click', ['$event'])
  onClick(event: Event) {
    event.stopImmediatePropagation();
  }
}
